import { all } from 'redux-saga/effects';

import addressCreateSaga from 'domain/addressBook/components/Create/saga';
import addressEditSaga from 'domain/addressBook/components/Edit/saga';
import zonesSaga from 'domain/addressBook/zone/saga';

function* watcher(context) {
  yield all([addressCreateSaga(context), addressEditSaga(context), zonesSaga(context)]);
}

export default watcher;
